export enum MainWindow {
  EMAILS = 'emails',
  EDITOR = 'editor',
  CAMERA = 'camera',
  STATS = 'stats',
  FORUM = 'forum',
}
